import { render, staticRenderFns } from "./pageLayout.vue?vue&type=template&id=4e6c3ec2&scoped=true"
import script from "./pageLayout.vue?vue&type=script&lang=js"
export * from "./pageLayout.vue?vue&type=script&lang=js"
import style0 from "./pageLayout.vue?vue&type=style&index=0&id=4e6c3ec2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6c3ec2",
  null
  
)

export default component.exports